import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                { label: t('email.emails'), icon: 'pi pi-fw pi-envelope', to: 'emails' },
                { label: t('general.dashboard'), icon: 'pi pi-fw pi-objects-column', to: 'dashboard' },
                { label: t('user.users'), icon: 'pi pi-fw pi-user', to: 'users' },
                { label: t('project.projects'), icon: 'pi pi-fw pi-briefcase', to: 'projects' },
                { label: t('allowed_outbound_email.allowed_outbound_email'), icon: 'pi pi-fw pi-list-check', to: 'allowed-outbound-emails' },
                { label: t('smtp_provider.smtp_providers'), icon: 'pi pi-fw pi-at', to: 'smtp-providers' }
            ]
        }
    ]
}
